import { ArrowDown } from 'lucide-react'
import ProfilePhoto from '../assets/ProfilePhoto'

export default function Hero() {
  return (
    <section className="min-h-screen flex items-center justify-center section-padding pt-24">
      <div className="max-w-6xl mx-auto w-full flex flex-col-reverse md:flex-row items-center gap-12">
        {/* Text */}
        <div className="flex-1 text-center md:text-left animate-slide-up">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-surface-container-high mb-6 border-l-2 border-primary">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
            <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-on-surface-variant">Bridging Tech & Business</span>
          </div>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-[0.9] mb-4 font-headline tracking-tighter">
            Solution-Builder <br />
            <span className="text-primary">AI & Sales Engineering</span>
          </h1>
          <p className="text-lg md:text-xl text-on-surface-variant max-w-2xl mb-8 leading-relaxed">
            Dynamic Engineer specializing in <strong className="text-white">NLP Engineering</strong> and <strong className="text-white">Solutions Architecture</strong>. I build scalable data pipelines and operationalize AI solutions, bridging the gap between technical complexity and strategic business value through <strong className="text-white">Rapid Prototyping</strong>.
          </p>
          <div className="flex flex-wrap gap-4 mb-12 justify-center md:justify-start">
            <a
              href="#projects"
              className="bg-primary text-on-primary px-8 py-4 rounded-xl font-bold font-headline text-lg hover:shadow-[0_0_20px_rgba(164,230,255,0.3)] transition-all flex items-center gap-2"
            >
              View Projects
              <span className="material-symbols-outlined text-sm">arrow_forward</span>
            </a>
            <a
              href="#contact"
              className="bg-surface-container-high border border-outline-variant/20 text-on-surface px-8 py-4 rounded-xl font-bold font-headline text-lg hover:bg-surface-container-highest transition-all"
            >
              Get in Touch
            </a>
          </div>
          {/* Highlights Bento Snippets */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="p-4 bg-surface-container-low rounded-xl">
              <div className="text-primary mb-2 text-2xl">⚡</div>
              <h4 className="text-xs font-bold text-on-surface-variant uppercase tracking-widest mb-1">Solutions Eng.</h4>
              <p className="text-sm font-medium">Sales Engineering</p>
            </div>
            <div className="p-4 bg-surface-container-low rounded-xl border border-primary/20">
              <div className="text-primary mb-2 text-2xl">🚀</div>
              <h4 className="text-xs font-bold text-on-surface-variant uppercase tracking-widest mb-1">Rapid Prototyper</h4>
              <p className="text-sm font-medium">Client-Facing MVP</p>
            </div>
            <div className="p-4 bg-surface-container-low rounded-xl">
              <div className="text-primary mb-2 text-2xl">🧠</div>
              <h4 className="text-xs font-bold text-on-surface-variant uppercase tracking-widest mb-1">NLP Engineering</h4>
              <p className="text-sm font-medium">LLM & Audio Synthesis</p>
            </div>
          </div>
        </div>

        {/* Photo */}
        <div className="flex-shrink-0 animate-fade-in relative">
          <ProfilePhoto />
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-primary/10 rounded-full blur-[80px]"></div>
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-primary/10 rounded-full blur-[80px]"></div>
        </div>
      </div>

      {/* Scroll indicator */}
      <a
        href="#about"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-gray-600 hover:text-primary transition-colors animate-bounce"
        aria-label="Scroll down"
      >
        <ArrowDown size={24} />
      </a>
    </section>
  )
}
